import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, Col, Form, Input, Row } from 'antd';
import { branchAccessEndpoints, qzTrayApiEndpoints } from '@/api/endpoints';
import { handlePostApi } from '@/api/crud';
import { useFetch } from '@/hooks';
// import { optionSearchFunction } from '@/utils/common';
import GlobalDivider from '@/utils/divider/GlobalDivider';
import LoadingOverlay from '@/utils/loading/loadingOverlay';
import { AntRSelect } from '@/common/ant-components/AntRSelect';
import { useGetApiListNoToast, useMutateGetApi } from '@/apiError/apiShow';

const CreateQzTraySetup = () => {
  const [loading, setLoading] = useState(false);

  const [form] = Form.useForm();
  const navigate = useNavigate();

  const navigateToList = () => navigate('/transaction/qz-tray-setup/list/');
  const { data } = useFetch(branchAccessEndpoints.retrieveList);

  const { data: CompanyData } = useGetApiListNoToast('/company/access/list/');

  const {
    mutate: getMutate,
    data: BranchData,
    isPending: branchLoading,
  } = useMutateGetApi();

  return (
    <>
      <section className="">
        <Card>
          <Form
            className="username"
            form={form}
            onFinish={(value) => {
              handlePostApi(
                qzTrayApiEndpoints.create,
                value,
                setLoading,
                form,
                navigateToList,
              );
            }}
            layout="vertical"
          >
            <LoadingOverlay loading={loading} />
            <GlobalDivider name="Create Qz Tray Setup" />

            <Row gutter={24}>
              <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <AntRSelect
                  array={CompanyData?.data?.map((item) => ({
                    id: item.referenceId,
                    name: item.name,
                  }))}
                  onSelect={async (e) => {
                    if (e) {
                      getMutate({ url: `/companies/${e}/branches/` });
                    }
                  }}
                  renderKey={'name'}
                  valueKey={'id'}
                  placeholder="Select Company Name"
                  formProps={{
                    name: 'companyId',
                    label: 'Company Name',
                    rules: [
                      {
                        required: true,
                        message: 'Please select any one company',
                      },
                    ],
                  }}
                />
              </Col>

              <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <AntRSelect
                  array={BranchData?.data?.map((item) => ({
                    id: item.referenceId,
                    name: item.branchName,
                  }))}
                  loading={branchLoading}
                  renderKey={'name'}
                  valueKey={'id'}
                  placeholder="Select Branch Name"
                  formProps={{
                    name: 'branchId',
                    label: 'Branch Name',
                    rules: [
                      {
                        required: true,
                        message: 'Please select any one branch',
                      },
                    ],
                  }}
                />
              </Col>

              <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item label="Private Key" name="privateKey">
                  <Input placeholder="Enter private key" />
                </Form.Item>
              </Col>

              <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                <Form.Item label="Digital Certificate" name="certificateKey">
                  <Input placeholder="Enter digital certificate" />
                </Form.Item>
              </Col>
            </Row>

            <div className="flex justify-end">
              <div className="flex gap-2">
                <Button type="primary" htmlType="submit">
                  Create
                </Button>
                <Button
                  className="auto-danger-btn"
                  onClick={() => navigate(-1)}
                >
                  Back
                </Button>
              </div>
            </div>
          </Form>
        </Card>
      </section>
    </>
  );
};

export default CreateQzTraySetup;
